export default "__VITE_ASSET__R4WT4Lu9__"